import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Standard } from 'components/Page';
import config from './config';

const CompetencyTypes = ({ permissions }) => (
  <Standard
    canAdmin={permissions.CanAdminCompetencies()
      .hasPermissions()}
    reducer={{
      item: REDUCER_KEY.competencyType,
      list: REDUCER_KEY.competencyTypes
    }}
    config={config}
  />
);

CompetencyTypes.propTypes = {
  permissions: PropTypes.object.isRequired
};

export default CompetencyTypes;
